import { ChildNodeType, NodeType } from "@/app/chatbots/utils/enums";
import { ChannelType } from "@/app/shared/utils/enums";

export function formatUpdateFormState(form) {
  let updateBody = {};

  const {
    name,
    description,
    arrayRangePickers,
    channels_customers,
    wait_time_action,
    timer,
    timer_message,
    queue,
    portfolio,
  } = form;

  if (name) updateBody.name = name;
  if (description) updateBody.description = description;
  if (channels_customers) updateBody.channels_customers = channels_customers;

  if (arrayRangePickers) {
    const formattedHours = arrayRangePickers?.flatMap((range) => {
      const weekday = range?.day;
      const hours = range?.hours?.map((hour) => {
        const start_hour = hour?.start ? `${hour.start.substring(0, 5)}:00` : null;
        const end_hour = hour?.end ? `${hour.end.substring(0, 5)}:59` : null;

        return {
          weekday,
          start_hour,
          end_hour,
        };
      });

      return hours;
    });

    updateBody.schedules = formattedHours;
  }

  if (wait_time_action) {
    updateBody = { ...updateBody, wait_time_action, timer, timer_message, queue, portfolio };
  }

  return updateBody;
}

export function hasChildNodes(parentNodeType) {
  return ChildNodeType[parentNodeType];
}

export function validateNodeType(specificNodeType, generalNodeType) {
  if (generalNodeType === NodeType.Buttons) {
    return [NodeType.Buttons, NodeType.ButtonOption].includes(specificNodeType);
  }

  if (generalNodeType === NodeType.List) {
    return [NodeType.List, NodeType.ListSection, NodeType.ListSectionItem].includes(
      specificNodeType
    );
  }

  if (generalNodeType === NodeType.Card) {
    return [NodeType.Card, NodeType.CardSection].includes(specificNodeType);
  }

  return false;
}

export function channelHasNodeType(channelType, nodeType) {
  if ([NodeType.Message, NodeType.Options].includes(nodeType)) return channelType;
  
  if (nodeType === NodeType.Buttons)
    return [ChannelType.Inbound, ChannelType.Messenger, ChannelType.Whatsapp].includes(channelType);

  if (nodeType === NodeType.List) return [ChannelType.Whatsapp].includes(channelType);
  if (nodeType === NodeType.Card)
    return [ChannelType.Messenger, ChannelType.Inbound].includes(channelType);

  return false;
}
